"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[25678],{

/***/ 63689:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Zb": function() { return /* binding */ DateDescendingOrder; },
/* harmony export */   "ar": function() { return /* binding */ DateAscendingOrder; },
/* harmony export */   "bI": function() { return /* binding */ PhoneNumberValidator; },
/* harmony export */   "dl": function() { return /* binding */ NumberWithCommas; },
/* harmony export */   "nO": function() { return /* binding */ CheckEmail; },
/* harmony export */   "qn": function() { return /* binding */ UseCountDescendingOrder; },
/* harmony export */   "wz": function() { return /* binding */ UsedTimeDescendingOrder; }
/* harmony export */ });
/* unused harmony exports NumberFormatCustom, RankingOrder */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_number_format__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57333);






/* 숫자 콤마 추가 */ var NumberWithCommas = function(x) {
    if (x) {
        var regexp = /\B(?=(\d{3})+(?!\d))/g;
        return x.toString().replace(regexp, ",");
    } else {
        return x;
    }
};
/* 숫자만 표기 & 콤마 표시 */ var NumberFormatCustom = function(props) {
    var inputRef = props.inputRef, onChange = props.onChange, other = _object_without_properties(props, [
        "inputRef",
        "onChange"
    ]);
    return /*#__PURE__*/ _jsx(NumberFormat, _object_spread_props(_object_spread({}, other), {
        getInputRef: inputRef,
        onValueChange: function(values) {
            onChange({
                target: {
                    name: props.name,
                    value: values.value
                }
            });
        },
        thousandSeparator: true,
        isNumericString: true
    }));
};
/* 전화번호 유효성 체크 */ var PhoneNumberValidator = function(args) {
    if (/^((01[1|6|7|8|9])[1-9]+[0-9]{6,7})|(010[1-9][0-9]{7})$/.test(args)) {
        return true;
    }
    return false;
};
/* 이메일 유효성 체크 */ var CheckEmail = function(str) {
    var reg_email = /^([0-9a-zA-Z_\.-]+)@([0-9a-zA-Z_-]+)(\.[0-9a-zA-Z_-]+){1,2}$/;
    if (!reg_email.test(str)) {
        return false;
    } else {
        return true;
    }
};
/* 날짜 내림차순 정렬 */ var DateDescendingOrder = function(a, b) {
    var dateA = new Date(a.createdAt).getTime();
    var dateB = new Date(b.createdAt).getTime();
    return dateA < dateB ? 1 : -1;
};
/* 날짜 내림차순 정렬 */ var UsedTimeDescendingOrder = function(a, b) {
    var dateA = new Date(a.usedTime).getTime();
    var dateB = new Date(b.usedTime).getTime();
    return dateA < dateB ? 1 : -1;
};
/* 날짜 오름차순 정렬 */ var DateAscendingOrder = function(a, b) {
    var dateA = new Date(a.createdAt).getTime();
    var dateB = new Date(b.createdAt).getTime();
    return dateA > dateB ? 1 : -1;
};
/* 랭킹 정렬 */ var RankingOrder = function(a, b) {
    return a.useCount > b.useCount ? 1 : -1;
};
/* 사용횟수 내림차순 정렬 */ var UseCountDescendingOrder = function(a, b) {
    return a.useCount < b.useCount ? 1 : -1;
};


/***/ }),

/***/ 8522:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* reexport safe */ firebaseConfig_config__WEBPACK_IMPORTED_MODULE_0__.vY; }
/* harmony export */ });
/* harmony import */ var firebaseConfig_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36068);


(0,firebaseConfig_config__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)();



/***/ }),

/***/ 89518:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ PageTokenCheck; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97582);
/* harmony import */ var jsonwebtoken__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49704);
/* harmony import */ var jsonwebtoken__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jsonwebtoken__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var function_LogOut__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39222);




/* 회원 비회원 token 값 체크 */ var PageTokenCheck = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(settings, router) {
        var tokenValue;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            tokenValue = window.localStorage.getItem("aisoToken");
            if (tokenValue === "" || tokenValue === null) {
                settings.login = false;
                settings.email = "";
                settings.name = "";
                settings.photo = "";
                settings.uid = "";
                // window.localStorage.removeItem("aisoToken");
                router.push("/user/market");
                ;
            } else {
                /* 만료된 토큰인지 체크해야함 */ // const tokenParseValue = jwt.verify(tokenValue, process.env.SECRET_CODE);
                jsonwebtoken__WEBPACK_IMPORTED_MODULE_0__.verify(tokenValue, "sdkjkdlsAESRcdslkch", function(error, decoded) {
                    ;
                    if (error) {
                        /* 만료된 토큰임. token 삭제하기 */ // window.localStorage.removeItem("aisoToken");
                        (0,function_LogOut__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(settings);
                        router.push("/user/market");
                    } else {
                        var email = decoded.email, name = decoded.name, uid = decoded.uid;
                        settings.login = true;
                        settings.email = email;
                        settings.name = name;
                        settings.uid = uid;
                        var setTokenValue = jsonwebtoken__WEBPACK_IMPORTED_MODULE_0__.sign({
                            email: email,
                            name: name,
                            uid: uid
                        }, "sdkjkdlsAESRcdslkch", {
                            expiresIn: "1d"
                        });
                        window.localStorage.setItem("aisoToken", setTokenValue);
                        if (router && router.asPath === "/") {
                            router.push("/user/market");
                        } else {
                            router.push(router.asPath);
                        }
                    }
                });
            }
            return [
                2
            ];
        });
    });
    return function PageTokenCheck(settings, router) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 25678:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var stores_settings__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31806);
/* harmony import */ var react_awesome_modal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20890);
/* harmony import */ var components_Function__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63689);
/* harmony import */ var components_Alert__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34950);
/* harmony import */ var _material_ui_core_TextField__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(33426);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79794);
/* harmony import */ var components_ProjectStorage__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8522);
/* harmony import */ var _profilePhone__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(29988);
/* harmony import */ var function_PageTokenCheck__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(89518);
/* harmony import */ var jsonwebtoken__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(49704);
/* harmony import */ var jsonwebtoken__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(jsonwebtoken__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _material_ui_icons_Wallpaper__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(56874);
/** @format */ 















var Profile = function() {
    var settings = (0,stores_settings__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), data = ref[0], setData = ref[1];
    /* 로그인 체크 : url 이동 */ (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        (0,function_PageTokenCheck__WEBPACK_IMPORTED_MODULE_10__/* .PageTokenCheck */ .C)(settings, router);
    }, []);
    var email = settings.email;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (email) try {
            var docRef = components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_7__/* .projectFirestore.collection */ .H.collection("users").doc("".concat(email));
            docRef.get().then(function(doc) {
                if (doc.exists) {
                    setData(doc.data());
                }
            }).catch(function(error) {
                ;
                (0,components_Alert__WEBPACK_IMPORTED_MODULE_5__/* .BasicAlert */ .N)(error);
            });
        } catch (error) {
            ;
        }
    }, [
        email
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "border-table",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProfileForm, {
            data: data
        })
    });
};
/* 디테일 페이지 상단 메뉴 */ var ProfileForm = function(param) {
    var data = param.data;
    var settings = (0,stores_settings__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    // 모달 값 저장
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), modalVisible = ref[0], setModalVisible = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), myName = ref1[0], setMyName = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), myPhone = ref2[0], setMyPhone = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), myPhoto = ref3[0], setMyPhoto = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), file = ref4[0], setFile = ref4[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (data) {
            var name = data.name, photo = data.photo, phone = data.phone;
            /* 기존 정산정보 저장 */ setMyName(name);
            setMyPhone(phone);
            setMyPhoto(photo);
        }
    }, [
        data
    ]);
    /* 기본사진 버튼 클릭 */ var handleBasicPhotoClick = function() {
        /* input value 값을 지워줘야 동일한 파일이 올라올 때 이벤트 발생함. */ document.getElementById("imageFileId").value = "";
        setMyPhoto("");
        setFile();
    };
    /* 사진변경 버튼 클릭 */ var handlePhotoChange = function(e) {
        setFile(e.target.files[0]);
    };
    /* profile 정보 업데이트 */ var handleProfileUpdate = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(function() {
            var email, storageFilePath, storageFileRef, docRef, _tmp, error, docRef1, _tmp1, error1;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        email = settings.email;
                        // 닉네임 체크
                        if (!myName) {
                            (0,components_Alert__WEBPACK_IMPORTED_MODULE_5__/* .BasicAlert */ .N)("닉네임을 입력해주세요.");
                            return [
                                2
                            ];
                        }
                        if (myName.length > 15) {
                            (0,components_Alert__WEBPACK_IMPORTED_MODULE_5__/* .BasicAlert */ .N)("닉네임은 한글, 영문 15자 이내의 자리수만 입력할 수 있습니다.");
                            return [
                                2
                            ];
                        }
                        // 전화번호 유효성 체크
                        if (myPhone) {
                            if (!(0,components_Function__WEBPACK_IMPORTED_MODULE_4__/* .PhoneNumberValidator */ .bI)(myPhone)) {
                                (0,components_Alert__WEBPACK_IMPORTED_MODULE_5__/* .BasicAlert */ .N)("전화번호를 다시 입력해주세요.");
                                return [
                                    2
                                ];
                            }
                        }
                        storageFilePath = "users/".concat(email, "/profile.jpg");
                        storageFileRef = components_ProjectStorage__WEBPACK_IMPORTED_MODULE_8__/* .projectStorage.ref */ .v.ref(storageFilePath);
                        if (!file) return [
                            3,
                            1
                        ];
                        storageFileRef.put(file).on("state_changed", function(snap) {
                            var percentage = snap.bytesTransferred / snap.totalBytes * 100;
                            ;
                        // setProgress(percentage);
                        }, function(err) {
                            ;
                        }, /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(function() {
                            var url, docRef, _tmp, error;
                            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_13__.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            storageFileRef.getDownloadURL()
                                        ];
                                    case 1:
                                        url = _state.sent();
                                        _state.label = 2;
                                    case 2:
                                        _state.trys.push([
                                            2,
                                            4,
                                            ,
                                            5
                                        ]);
                                        docRef = components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_7__/* .projectFirestore.collection */ .H.collection("users").doc("".concat(email));
                                        _tmp = {};
                                        return [
                                            4,
                                            docRef.update((_tmp.photo = url, _tmp))
                                        ];
                                    case 3:
                                        _state.sent();
                                        return [
                                            3,
                                            5
                                        ];
                                    case 4:
                                        error = _state.sent();
                                        return [
                                            3,
                                            5
                                        ];
                                    case 5:
                                        /* mobx에도 저장 */ settings.photo = url;
                                        return [
                                            2
                                        ];
                                }
                            });
                        }));
                        return [
                            3,
                            6
                        ];
                    case 1:
                        if (!(myPhoto === "")) return [
                            3,
                            6
                        ];
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        docRef = components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_7__/* .projectFirestore.collection */ .H.collection("users").doc("".concat(email));
                        _tmp = {};
                        return [
                            4,
                            docRef.update((_tmp.photo = "", _tmp))
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 5:
                        /* mobx에도 저장 */ settings.photo = "";
                        _state.label = 6;
                    case 6:
                        _state.trys.push([
                            6,
                            8,
                            ,
                            9
                        ]);
                        docRef1 = components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_7__/* .projectFirestore.collection */ .H.collection("users").doc("".concat(email));
                        _tmp1 = {};
                        return [
                            4,
                            docRef1.update((_tmp1.name = myName, _tmp1.phone = myPhone ? myPhone : "", _tmp1)).then(function() {
                                /* token or setting값 도 바꾸기 */ settings.name = myName;
                                var tokenValue = jsonwebtoken__WEBPACK_IMPORTED_MODULE_11__.sign({
                                    email: email,
                                    name: myName,
                                    uid: uid
                                }, "sdkjkdlsAESRcdslkch", {
                                    expiresIn: "1d"
                                });
                                window.localStorage.setItem("aisoToken", tokenValue);
                                var text = "적용되었습니다.";
                                (0,components_Alert__WEBPACK_IMPORTED_MODULE_5__/* .SuccessAlert */ .I)(text);
                                return;
                            })
                        ];
                    case 7:
                        _state.sent();
                        return [
                            3,
                            9
                        ];
                    case 8:
                        error1 = _state.sent();
                        return [
                            3,
                            9
                        ];
                    case 9:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleProfileUpdate() {
            return _ref.apply(this, arguments);
        };
    }();
    var closeModal = function() {
        setModalVisible(false);
    };
    var handleModalOkButton = function() {
        setModalVisible(false);
        handleProfileUpdate();
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "lg:px-40 xl:px-52",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                className: "col-form-label w-full",
                children: "프로필 사진"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-col",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "center",
                        children: file ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "img-cover-box rounded-full border min-w-min h-20 w-20 sm:w-28 sm:h-28",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                className: "rounded-full ",
                                src: URL.createObjectURL(file),
                                alt: ""
                            })
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "img-cover-box rounded-full border min-w-min h-20 w-20 center sm:w-28 sm:h-28",
                            children: myPhoto === "" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Wallpaper__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                                style: {
                                    width: "80%",
                                    height: "80%"
                                }
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                className: "rounded-full",
                                src: myPhoto,
                                alt: ""
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex justify-center items-center mt-3",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "px-1",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    className: "relative btn glass_in_outline_btn cursor-pointer",
                                    onClick: handleBasicPhotoClick,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                        className: "m-0 p-0 cursor-pointer",
                                        htmlFor: "customFile",
                                        children: "기본사진"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "px-1",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                    className: "relative btn glass_in_outline_btn cursor-pointer",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                            type: "file",
                                            className: "custom-file-input cursor-pointer",
                                            id: "imageFileId",
                                            accept: "image/png, image/jpeg",
                                            onChange: function(e) {
                                                return handlePhotoChange(e);
                                            }
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
                                            className: "m-0 p-0 cursor-pointer",
                                            htmlFor: "customFile",
                                            children: "사진변경"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "my-3",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_TextField__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                    label: "닉네임",
                    placeholder: "닉네임을 입력해주세요.",
                    fullWidth: true,
                    margin: "normal",
                    InputLabelProps: {
                        shrink: true
                    },
                    className: "my-3",
                    value: myName,
                    onChange: function(e) {
                        return setMyName(e.target.value);
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "my-3",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_profilePhone__WEBPACK_IMPORTED_MODULE_9__["default"], {
                    myPhone: myPhone,
                    setMyPhone: setMyPhone
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    className: "btn glass_in_btn",
                    onClick: function() {
                        return setModalVisible(true);
                    },
                    children: "적용하기"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_awesome_modal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                visible: modalVisible,
                width: "400",
                height: "210",
                effect: "fadeInUp",
                onClickAway: function() {
                    return closeModal();
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "aiso-modal",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "aiso-modal-header",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                className: "btn btn-text-grayPrimary p-3",
                                onClick: function() {
                                    return setModalVisible(false);
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                    className: "ti-close font-bold"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "aiso-modal-body text-center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                    className: "text-xl font-bold text-primary mb-0",
                                    id: "modal-title",
                                    children: "적용 하시겠습니까?"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "mt-2",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-xs text-gray-500",
                                        children: "적용을 원하시면 확인 버튼을 눌러주세요."
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "aiso-modal-footer text-center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                type: "button",
                                className: "btn btn-modal-o w-1/3",
                                onClick: function() {
                                    return handleModalOkButton();
                                },
                                children: "확인"
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Profile);


/***/ }),

/***/ 29988:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_text_mask__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91749);
/* harmony import */ var react_text_mask__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_text_mask__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _material_ui_core_Input__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(38799);
/* harmony import */ var _material_ui_core_InputLabel__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85161);
/* harmony import */ var _material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(64436);
/** @format */ 









var TextMaskCustom = function(props) {
    var inputRef = props.inputRef, other = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, [
        "inputRef"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_text_mask__WEBPACK_IMPORTED_MODULE_2___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, other), {
        ref: function(ref) {
            inputRef(ref ? ref.inputElement : null);
        },
        mask: [
            /[0-9]/,
            /\d/,
            /\d/,
            " ",
            " ",
            "-",
            " ",
            " ",
            /\d/,
            /\d/,
            /\d/,
            /\d/,
            " ",
            " ",
            "-",
            " ",
            " ",
            /\d/,
            /\d/,
            /\d/,
            /\d/
        ],
        placeholderChar: " ",
        showMask: true
    }));
};
TextMaskCustom.propTypes = {
    inputRef: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().func.isRequired)
};
var FormattedInputs = function(param) {
    var myPhone = param.myPhone, setMyPhone = param.setMyPhone;
    var handleChange = function(event) {
        /** 공백, - 표시 제거 */ var value = event.target.value.replace(/(\s*)/g, "").replace(/(\-)/g, "");
        setMyPhone(value);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_material_ui_core_FormControl__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            className: "w-full my-3",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_InputLabel__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    htmlFor: "formatted-text-mask-input",
                    children: "전화번호"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Input__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    value: myPhone,
                    onChange: handleChange,
                    name: "textmask",
                    id: "formatted-text-mask-input",
                    inputComponent: TextMaskCustom
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (FormattedInputs);


/***/ })

}]);